import Alert from 'common/components/alert/Alert';
import AlertType from 'common/types/AlertType';
import ChsAttachment from 'domain/types/ChsAttachment';
import React from 'react';
import {
  Button,
  FormControl,
  FormFile,
  FormGroup,
  FormLabel,
  FormText,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CodeTableOptions from '../codetable/CodeTableOptions';
import { ReuploadLocationState } from './ReuploadLocationState';
import VerificationStatus from './VerificationStatus';
import VerifyAlert from './VerifyAlert';

interface IVerifyIdentityPresenter {
  hasPostDraftApplications: boolean;
  status: VerificationStatus | null | undefined;
  allowedFileTypes: string | null;
  attachment: ChsAttachment | null;
  postSuccess: boolean | undefined;
  postError: string | undefined;
  onSubmit: (e: React.SyntheticEvent) => void;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  loading: boolean;
  saving: boolean;
  locationState: ReuploadLocationState;
  canReupload: boolean;
}

const VerifyIdentityPresenter = (props: IVerifyIdentityPresenter) => {
  let alert;

  if (props.postSuccess) {
    if (props.locationState) {
      const { onReupload } = props.locationState;
      alert = (
        <Alert type={AlertType.success}>
          {onReupload.message}{' '}
          <Link to={onReupload.to} className='ml-2'>
            {onReupload.linkText}
          </Link>
        </Alert>
      );
    } else {
      alert = (
        <Alert type={AlertType.success}>
          Identity document has been uploaded.
        </Alert>
      );
    }
  } else if (props.postError) {
    alert = (
      <Alert type={AlertType.danger}>
        The identity document was not uploaded. {props.postError}
      </Alert>
    );
  } else if (props.status) {
    alert = (
      <VerifyAlert
        status={props.status}
        filename={props.attachment?.filename || '(empty)'}
      />
    );
  }

  return (
    <>
      {alert}
      {props.canReupload && (
        <form onSubmit={props.onSubmit}>
          <FormGroup>
            <FormLabel htmlFor='attachmentTypeCd'>Document Type: *</FormLabel>
            <FormControl
              name='attachmentTypeCd'
              as='select'
              disabled={props.saving}
            >
              <CodeTableOptions endpoint='/identityAttachments' includeEmpty />
            </FormControl>
          </FormGroup>
          <FormGroup>
            <FormLabel htmlFor='files'>Document: *</FormLabel>
            <FormFile
              type='file'
              onChange={props.handleFileChange}
              name='files'
              disabled={props.saving}
            />
            <FormText className='text-muted'>
              Allowed File Types: {props.allowedFileTypes || ''}
            </FormText>
            <FormText className='text-muted'>
              All identity documents must be current/unexpired and legible.
            </FormText>
          </FormGroup>
          <Button type='submit' variant='primary' disabled={props.saving}>
            Submit
          </Button>
        </form>
      )}
    </>
  );
};

export default VerifyIdentityPresenter;
